export class ReferralIngestionMapperSourceColumn {
  index = 0;

  name = '';

  constructor(obj: any) {
    Object.assign(this, obj);
  }

  static toString(item?: ReferralIngestionMapperSourceColumn) {
    if (!item) return '';
    if (item.index) return `${item.name} (${item.index + 1})`;
    return item.name || '';
  }
}

export default ReferralIngestionMapperSourceColumn;
